/*
 * @Date: 2025-02-28 20:10:16
 * @LastEditors: Wang Xiaomei XianYuPigeon@outlook.com
 * @LastEditTime: 2025-03-06 06:15:48
 * @FilePath: /personal-page/src/main.ts
 */
import { createApp } from 'vue'
import App from './App.vue'
import './assets/styles/typography.css' // 导入字体样式表

createApp(App).mount('#app')
